import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Disclaimer from '../Disclaimer/Disclaimer.js';
import { IDisclaimerProps } from '../Disclaimer/models/index.js';

import { IDisclaimersConfiguration, IDisclaimersProps, IDisclaimersState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { DISCLAIMERS_CATEGORY_KEY, DISCLAIMERS_COMPONENT_KEY } from './Disclaimers.meta.js';

export class Disclaimers extends ComponentBase<IDisclaimersProps, IDisclaimersState, IDisclaimersConfiguration> {
	categoryKey = DISCLAIMERS_CATEGORY_KEY;
	componentKey = DISCLAIMERS_COMPONENT_KEY;

	constructor(props: IDisclaimersProps) {
		super(props);
	}

	render() {
		const { className, disclaimers, hasHtmlContent, separator, defaultProps } = this.props;

		if (common.commonUtils.isNullOrEmpty(disclaimers)) {
			return null;
		}

		return (
			<Wrapper className={className}>
				{disclaimers.length > 0 &&
					disclaimers.map((disclaimer, index) => {
						const disclaimerProps: IDisclaimerProps = {
							separator,
							hasHtmlContent,
							...defaultProps,
							...disclaimer,
							// The global disclaimer text getter does not spread here so we need to be explicit
							text: disclaimer.text,
							useSeparator: index < disclaimers.length - 1,
						};
						return <Disclaimer key={`disclaimer-${index}`} {...disclaimerProps} />;
					})}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(Disclaimers), DISCLAIMERS_CATEGORY_KEY, DISCLAIMERS_COMPONENT_KEY);
